import { GrocyProductBasics } from '../../../../core/entities/grocy/products/product-basics.entity';
import { BaseForm } from '../../../../forms/forms/base.form';
import { GrocyDashboardProductFormControls } from '../form-controls/dashboard-product.form-controls';
import { GrocyDashboardProductFormOptions } from '../form-options/dashboard-product.form-options';

export class GrocyDashboardProductForm extends BaseForm<GrocyDashboardProductFormControls> {
  barcodeExists = false;
  formGroup = this.createFormGroup(GrocyDashboardProductFormControls);
  override options = new GrocyDashboardProductFormOptions();

  get barcode(): string | null {
    return this.controls.barcode.value;
  }

  get inStockSubProductOptions(): GrocyProductBasics[] {
    return this.options.grocyProducts.filter(subProductOption => subProductOption.stockAmount > 0);
  }

  override clear(): void {
    super.clear();
    this.barcodeExists = false;
  }

  disable(): void {
    this.controls.barcode.disable();
    this.controls.product.disable();
  }

  enable(): void {
    this.controls.barcode.enable();
    this.controls.product.enable();
  }
}
